import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "@/components/Header";
import BottomNav from "@/components/BottomNav";
import Footer from "@/components/Footer";
import { OnboardingProvider } from "@/components/Onboarding";
import VerifyEmailSheet from "@/components/VerifyEmailSheet";
import VerifyEmailBanner from "@/components/VerifyEmailBanner";

export default function Layout() {
  const loc = useLocation();
  const hideNav = loc.pathname === "/login" || loc.pathname === "/registar" || loc.pathname === "/esqueci" || loc.pathname.startsWith("/reset-password");
  const immersive = loc.pathname === "/feed"; // Feed em ecrã cheio: sem rodapé, tema escuro no cabeçalho e na barra inferior
  useEffect(() => {
    if (!immersive) return;
    const prev = document.documentElement.style.overflow;
    document.documentElement.style.overflow = "hidden"; // a página não rola; só o scroller do Feed
    window.scrollTo(0, 0);
    return () => { document.documentElement.style.overflow = prev; };
  }, [immersive]);
  return (
    <OnboardingProvider>
    <div className={`App min-h-screen flex flex-col ${immersive ? "bg-[#0d0d0d]" : "bg-[#fafafa]"}`} data-immersive={immersive}>
      {!hideNav && <Header dark={immersive} />}
      {!hideNav && <VerifyEmailBanner />}
      <VerifyEmailSheet />
      <main className={`flex-1 ${immersive ? "" : "pt-2"}`}>
        <Outlet />
      </main>
      {!hideNav && !immersive && <Footer />}
      {!hideNav && <BottomNav dark={immersive} />}
    </div>
    </OnboardingProvider>
  );
}
